var path = '/assets/js/dashboard/financials/fees/fees.html';
var html = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <kickbacks applicable-company=\"$ctrl.company\" applied-type=\"Ticket\"></kickbacks>\n    </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;